import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BRAND_VOICE, FRAGMENT_BRAND_VOICE_ASSETS } from './schema';

const QUERY = gql`
  query BrandVoiceWithAssets($id: ID!) {
    brandVoice(id: $id) {
      ...BrandVoice
      ...BrandVoiceAssets
    }
  }
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_BRAND_VOICE_ASSETS}
`;

export const queryBrandVoiceWithAssets = async (id) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { id },
  });
  return getSingleProp(result.data);
};
